import { Link } from "react-router-dom";
import { LEGAL_PAGES, LEGAL_LINKS, SELLER } from "../content/legal";
import { renderInline } from "./legalText";
import SeoHead from "../Components/SeoHead";

export function LegalFooterLinks() {
  return (
    <nav className="flex flex-wrap justify-center gap-x-4 gap-y-1">
      {Object.values(LEGAL_LINKS).map((link) => (
        <Link key={link.path} to={link.path} className="underline hover:no-underline">
          {link.label}
        </Link>
      ))}
    </nav>
  );
}

const Card = ({ children }) => <section className="rounded-2xl border p-6 shadow-md bg-white">{children}</section>;

export default function LegalPage({ page }) {
  const doc = LEGAL_PAGES[page];
  return (
    <div className="min-h-screen bg-red-50 text-gray-800">
      <SeoHead title={doc.metaTitle} description={doc.metaDescription} path={doc.path} />
      <header className="sticky top-0 z-10 bg-red-50 backdrop-blur border-b">
        <div className="mx-auto max-w-3xl px-4 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-semibold">{doc.title}</h1>
          <a href="/" className="text-sm underline hover:no-underline">← Back to Home</a>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-10 space-y-8">
        <Card>
          <p className="text-sm text-gray-500">
            {doc.effective ? `Effective date: ${doc.effective} · ` : ""}Last updated: {doc.updated}
          </p>
          <p className="mt-3 leading-7">{renderInline(doc.intro)}</p>
        </Card>

        {doc.sections.map((section) => (
          <Card key={section.heading}>
            <h2 className="text-lg font-semibold">{section.heading}</h2>
            {section.paragraphs?.map((p) => (
              <p key={p} className="mt-3 leading-7">{renderInline(p)}</p>
            ))}
            {section.bullets && (
              <ul className="mt-3 list-disc pl-6 space-y-2">
                {section.bullets.map((b) => (
                  <li key={b}>{renderInline(b)}</li>
                ))}
              </ul>
            )}
            {section.subsections?.map((sub) => (
              <div key={sub.heading} className="mt-4">
                <h3 className="font-semibold">{sub.heading}</h3>
                {sub.paragraphs.map((p) => (
                  <p key={p} className="mt-2 leading-7">{renderInline(p)}</p>
                ))}
              </div>
            ))}
            {section.paragraphs2?.map((p) => (
              <p key={p} className="mt-3 leading-7">{renderInline(p)}</p>
            ))}
          </Card>
        ))}

        <footer className="py-8 flex flex-col items-center gap-3 text-xs text-gray-500">
          <LegalFooterLinks />
          <p>© {new Date().getFullYear()} {SELLER.tradingName} · A product of {SELLER.legalName}</p>
        </footer>
      </main>
    </div>
  );
}
